import { h, render, Component } from 'preact';
import 'normalize.css/normalize.css';
import 'water.css/out/water.css';
import './index.css';

import { DoubloonFunnel } from './doubloon-funnel.js';

class App extends Component {

  constructor() {
    super();

    // Get all of our relevant search params
    let searchParams = new URLSearchParams(document.location.search);
    let doubloonJsonUrl = searchParams.get('json');
    let doubloonPreview = searchParams.get('preview');
    let discount = searchParams.getAll('discount');
    let expireTime = searchParams.get('expiretime');
    let brandColor = searchParams.get('brandcolor');
    let doubloonRef = searchParams.get('doubloon-ref');

    this.state = {
      isLoadingJson: true,
      isLoadingCheckout: false,
      errorMessage: null,
      doubloonJson: null,
      doubloonJsonUrl,
      doubloonPreview,
      discount,
      expireTime,
      brandColor,
      doubloonRef
    };
  }

  componentDidMount() {
    const currentUrl = new URL(window.location.href);

    // Check if this is a preview
    let isPreview = this.state.doubloonPreview;
    let previewJson = localStorage.getItem('doubloon-preview-json');
    if (isPreview && previewJson) {
      setTimeout(() => {
        // Log the preview json
        let parsedPreviewJson = JSON.parse(previewJson);
        console.log('Parsed Preview JSON', parsedPreviewJson);
        this.setState({
          ...this.state,
          isLoadingJson: false,
          doubloonJson: parsedPreviewJson
        });
      }, 1000);

      // Don't fetch anything
      return;
    }
    
    const jsonUrls = [];
    if (this.state.doubloonJsonUrl || currentUrl.href.includes('json=')) {
      jsonUrls.push(this.state.doubloonJsonUrl);
    }

    if (currentUrl.href.includes('groovykaiju-mtz-fsh') || currentUrl.href.includes('/json/mtz/')) {
      jsonUrls.push(`${currentUrl.origin}/json/groovykaiju-mtz-fsh`);
    }

    const showErrorState = () => {
      this.setState({
        ...this.state,
        isLoadingJson: false,
        errorMessage: 'Could not fetch the configuration JSON. Please let the person who sent you this link know!'
      });
    }
    if (jsonUrls.length === 0) {
      showErrorState();
    }

    const fetchDoubloonJsonWithFallbacks = async () => {
      for (let i = 0; i < jsonUrls.length; i++) {
        const jsonUrl = jsonUrls[i];

        try {

          // Try to fetch the JSON
          const response = await fetch(jsonUrl);
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          
          // We got the JSON! Extract it, set the state, and stop trying!
          const data = await response.json();
          this.setState({
            ...this.state,
            isLoadingJson: false,
            doubloonJson: data,
            doubloonRef: (jsonUrls.length >= 1 && i === 0) ? this.state.doubloonRef : 'fallback'
          });
          i = jsonUrls.length;
          return data;

        } catch (error) {

          console.warn(`Doubloon: failed to fetch: ${jsonUrl} :`, error.message);
          if (i + 1 < jsonUrls.length) {
            console.warn(`Doubloon: Trying Fallback URL: ${jsonUrls[i + 1]}`);
          } else {

            // Everything Failed, just show the error state
            showErrorState();
          }
        }
      }
    }

    return fetchDoubloonJsonWithFallbacks();
  }

  render() {
    return (
      <div>
        
        {/* Brand Colors */}
        {this.state.brandColor ? (
          <style>{`
            :root {
              --brand-color: #${this.state.brandColor}
            }
          `}</style>
        ) : ''}

        {/* Messages to the User while parsing Doubloon JSON */}
        {(this.state.isLoadingJson || this.state.errorMessage) ? (() => {

          let htmlMessage = (
            <div class="full-screen-message__container">
              <div class="loading-spinner"></div>
              <h1>Loading...</h1>
            </div>
          );
          if (this.state.errorMessage) {
            htmlMessage = (
              <div class="full-screen-message__container">
                <div class="error-icon">🛑</div>
                <h1>Error: {this.state.errorMessage}</h1>
              </div>
            );
          }

          return (
            <div class="full-screen-message">
              {htmlMessage}
            </div>
          );
        })() : ''}

        {/* Our actual sales funnel */}
        {this.state.doubloonJson ? (() => {
          return (
            <DoubloonFunnel isPreview={this.state.doubloonPreview} json={this.state.doubloonJson} discount={this.state.discount} expireTime={this.state.expireTime} doubloonRef={this.state.doubloonRef} />
          );
        })() : ''}
      </div>
    );
  }
}

render(<App />, document.body);
